import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	root: {

	},
	registerButton: {
		marginRight: theme.spacing(2),
	}
}));
